export enum UserPermissions {
  None = 0,
  Read = 1,
  Modify = 2
}
